export default {
  filters: {
    getFileSize(kbs) {
      let mb = parseInt(kbs)/1024;
      return mb >= 1024 ? parseFloat(kbs/(1024 * 1024)).toFixed(2) + ' MB' : parseFloat(mb).toFixed(2) + ' KB';
    }
  }
}